import { pluralizeString } from '../../../shared/utils/stringUtils/pluralizeString/pluralizeString';
import {
  CaseType,
  textTransform,
} from '../../../shared/utils/stringUtils/textTransform/textTransform';
import { FOOD_TYPE, FoodType } from '../../constants/foodType';

export type FormatConfig = {
  case?: CaseType;
  pluralize?: boolean;
};
// should be in capital case and without pluralization by default
const foodTypeLabel: Record<FoodType, string> = {
  [FOOD_TYPE.CORE]: 'Core Food',
  [FOOD_TYPE.SUPPLEMENT]: 'Supplement',
  [FOOD_TYPE.VEGGIES]: 'Vegetable',
  [FOOD_TYPE.BARCODE]: 'Barcode Food',
};

export const getHumanizeFoodType = (
  foodType: FoodType,
  /**
   * @description Format config for the food type label
   * @default  case: 'capital', pluralize: false
   */
  formatConfig?: FormatConfig,
): string => {
  const { case: caseType, pluralize } = formatConfig ?? {};

  let label = foodTypeLabel[foodType] || foodType;

  if (pluralize) {
    label = pluralizeString(label);
  }

  if (caseType) {
    label = textTransform(label, caseType);
  }

  return label;
};
